import {Injectable} from '@angular/core';
import {CommerceState, selectSpecs, selectVariants} from '../reducers';
import {Store} from '@ngrx/store';
import {Observable, of} from 'rxjs';
import {switchMap, take} from 'rxjs/operators';
import {Specification, Variant} from '../../data/model';
import {SpecVariantApiService} from '../../data/api/service/spec-variant-api.service';

@Injectable({
  providedIn: 'root',
})
/**
 * Helper service for the AddonEffects to load product specifications, and variants.
 */
export class SpecificationService {
  constructor(
    private store: Store<CommerceState>,
    private apiService: SpecVariantApiService,
  ) {}

  getProductSpecifications(productId: string): Observable<Specification[]> {
    return this.store.select(selectSpecs).pipe(
      take(1),
      switchMap(specs => {
        if (specs && specs[productId]) {
          return of(specs[productId]);
        }
        return this.apiService.getSpecs(productId);
      }),
    );
  }

  getProductVariations(productId: string): Observable<Variant[]> {
    return this.store.select(selectVariants).pipe(
      take(1),
      switchMap(variants => {
        if (variants && variants[productId]) {
          return of(variants[productId]);
        }
        return this.apiService.variants(productId);
      }),
    );
  }
}
